import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';

@Component({
  selector: 'app-updated-email-req',
  templateUrl: './updated-email-req.component.html',
  styles: [
  ]
})
export class UpdatedEmailReqComponent extends BaseComponent implements OnInit {

  constructor(
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
  }

  // OnSubmit()
  onSubmit(): void {
    this.router.navigate(['secure/user/email/update']);
  }

  onCancel():void {
    this.router.navigate(['secure/myservices']);
  }


}